/* ==========================================================================
   Searcher > Client > helpers
   ========================================================================== */
/* Modules */
const { DateTime } = require('luxon');

const { CALENDAR } = require('../../../constants');

function formatDate(instance, dateTime, format = CALENDAR.stringDateFormat) {
    const { config = {} } = instance;
    const { context = {} } = config;
    const language = context.language || context.Language;

    return dateTime.setLocale(language).toFormat(format);
}

function firstAvailableDates(instance) {
    const { config = {} } = instance;

    const {
        dates: { releaseDays }
    } = config;

    const { dates = [], route = {} } = instance.store.select('data');
    const { outboundDates = [], returnDates = [] } = route;

    if (!outboundDates.length || !returnDates.length) return false;

    const startDateIsValid = !!dates.length && outboundDates.some(item => item.value === dates[0]);
    const endDateIsValid = startDateIsValid && !!dates.length && returnDates.some(item => item.value === dates[1]);

    /* Calculate the first day available for return */
    const firstReturnDate =
        !dates.length || !endDateIsValid
            ? DateTime.fromISO(outboundDates[0].value).plus({ days: releaseDays })
            : DateTime.fromISO(dates[0]).plus({ days: releaseDays });

    return {
        startDate: startDateIsValid ? dates[0] : outboundDates[0].value,
        endDate: endDateIsValid
            ? dates[1]
            : returnDates.find(item => DateTime.fromISO(item.value) > firstReturnDate).value
    };
}

function hasPanel(instance) {
    const { panel: panelOrigin } = instance.origin.store.select('data');
    const { panel: panelDestination } = instance.destination.store.select('data');
    const { panel: panelCalendar } = instance.calendarInput.store.select('data');
    const { panel: panelAccommodation } = instance.accommodationInput.store.select('data');
    const { panel: panelVehicle } = instance.vehicleInput.store.select('data');

    return panelOrigin || panelDestination || panelCalendar || panelAccommodation || panelVehicle;
}

module.exports = {
    firstAvailableDates,
    formatDate,
    hasPanel
};
